// src/container/EmailSchedulerList.jsx
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AppLoader from "../component/AppLoader";
import { AddEmailSchedulerPopup } from "../component/AddEmailSchedulerPopup";
import { 
  listEmailSchedules,
  clearEmailScheduleErrors 
} from "../Redux/action/EmailSchedulerAction";
import { 
  getEmailSchedulerListSelector, 
  getEmailSchedulerLoadingSelector, 
  getEmailSchedulerErrorSelector,
  getEmailSchedulerSuccessMessageSelector,
  getEmailSchedulerUpdatingSelector
} from "../Redux/reducer/EmailSchedulerReducer";
import nodatafound from '../asset/img/datanotfound_black.png';
// import { DeclinePopup } from "../component/DeclinePopup";

export const EmailSchedulerList = () => {
    const dispatch = useDispatch();
    
    const loading = useSelector(getEmailSchedulerLoadingSelector);
    const schedules = useSelector(getEmailSchedulerListSelector);
    const error = useSelector(getEmailSchedulerErrorSelector);
    const successMessage = useSelector(getEmailSchedulerSuccessMessageSelector);
    const updating = useSelector(getEmailSchedulerUpdatingSelector);
    
    const [popupData, setPopupData] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
     const [refreshFlag, setRefreshFlag] = useState(false);
    // const [itemToDelete, setItemToDelete] = useState(null);
    // const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        dispatch(listEmailSchedules());
    }, [dispatch , refreshFlag ]);

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            setTimeout(() => {
                dispatch(clearEmailScheduleErrors());
            }, 3000);
        }
    }, [successMessage, dispatch]);

    useEffect(() => {
        if (error?.message) {
            toast.error(error.message);
            if (error.errors) {
                Object.entries(error.errors).forEach(([key, value]) => {
                    if (Array.isArray(value)) {
                        value.forEach(msg => toast.error(`${key}: ${msg}`));
                    } else {
                        toast.error(`${key}: ${value}`);
                    }
                });
            }
            setTimeout(() => {
                dispatch(clearEmailScheduleErrors());
            }, 5000);
        }
    }, [error, dispatch]);


    const handleEdit = (schedule) => {
        const formattedSchedule = {
            ...schedule,
            scheduled_times: formatTimesForForm(schedule.scheduled_times)
        };
        setPopupData(formattedSchedule);
        setShowPopup(true);
    };

    // const handleDeleteClick = (schedule) => {
    //     setItemToDelete(schedule);
    //     setShowDeleteModal(true);
    // };

    // Handle delete confirmation
    // const handleDeleteConfirm = () => {
    //     if (!itemToDelete) return;
        
    //     // Note: Your backend doesn't have delete endpoint yet
    //     toast.info("Delete functionality requires backend implementation");
    //     setShowDeleteModal(false);
    //     setItemToDelete(null);
    // };

    const formatTimeForDisplay = (time) => {
        if (!time) return 'N/A';
        
        if (typeof time === 'string') {
            return time;
        } else if (typeof time === 'object') {
            if (time.hours !== undefined && time.minutes !== undefined) {
                return `${String(time.hours).padStart(2, '0')}:${String(time.minutes).padStart(2, '0')}`;
            }
        }
        return 'Invalid time';
    };

    const formatTimesForForm = (times) => {
        if (!times || !Array.isArray(times)) return [''];
        
        return times.map(time => {
            if (typeof time === 'string') {
                return time;
            } else if (typeof time === 'object') {
                if (time.hours !== undefined && time.minutes !== undefined) {
                    return `${String(time.hours).padStart(2, '0')}:${String(time.minutes).padStart(2, '0')}`;
                }
            }
            return '';
        });
    };

    const formatRecipients = (recipientList) => {
        if (!recipientList) return 'No recipients';
        
        if (Array.isArray(recipientList)) {
            return recipientList.join(', ');
        } else if (typeof recipientList === 'string') {
            return recipientList;
        }
        return 'Invalid recipient list';
    };

    // const handleAddNew = () => {
    //     setPopupData(null);
    //     setShowPopup(true);
    // };

    const handleClosePopup = () => {
        setPopupData(null);
        setShowPopup(false);
    };

    const handlePopupSuccess = () => {
        handleClosePopup();
        setRefreshFlag(prev => !prev);
        console.log("Refreshing email schedule list...",refreshFlag);
        dispatch(listEmailSchedules());
    };

    // const handleCloseDeleteModal = () => {
    //     setItemToDelete(null);
    //     setShowDeleteModal(false);
    // };

    return (
        <>
            {loading && <AppLoader />}
            
            <div className="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12">
                
                <div className="card">
                    <h5 className="card-header">Email Schedules</h5>

                    <div className="card-body p-0">
                        {schedules && schedules.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table onboardTable">
                                    <thead className="bg-light">
                                        <tr className="border-0">
                                            <th className="border-0">S.No</th>
                                            <th className="border-0">Schedule Name</th>
                                            <th className="border-0">Scheduled Times</th>
                                            <th className="border-0">Subject</th>
                                            <th className="border-0">Receiver</th>
                                            <th className="border-0">Recipients</th>
                                            <th className="border-0">Edit</th>
                                            {/* <th className="border-0">Delete</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {schedules.map((schedule, index) => (
                                            <tr key={schedule.id || index}>
                                                <td>{index + 1}</td>
                                                <td>{schedule.name || 'N/A'}</td>
                                                <td>
                                                    {schedule.scheduled_times && schedule.scheduled_times.length > 0 ? (
                                                        <div className="scheduled-times">
                                                            {schedule.scheduled_times.map((time, timeIndex) => (
                                                                <div key={timeIndex} className="time-item">
                                                                    {formatTimeForDisplay(time)}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div>No scheduled times</div>
                                                    )}
                                                </td>
                                                <td>{schedule.subject || 'N/A'}</td>
                                                <td>{schedule.receiver || 'N/A'}</td>
                                                <td>
                                                    <div className="recipients-truncate" title={formatRecipients(schedule.recipient_list)}>
                                                        {formatRecipients(schedule.recipient_list)}
                                                    </div>
                                                </td>
                                                <td>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-primary btn-sm" 
                                                        onClick={() => handleEdit(schedule)}
                                                    >
                                                        Edit
                                                    </button>
                                                </td>
                                                {/* <td>
                                                    <button 
                                                        type="button" 
                                                        className="btn btn-danger btn-sm" 
                                                        onClick={() => handleDeleteClick(schedule)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div className="text-center py-5">
                                <div className="mb-3">
                                    <img 
                                        src={nodatafound} 
                                        alt="No Data Found" 
                                        className="img-fluid"
                                        style={{ maxWidth: '200px' }}
                                    />
                                </div>
                                <h3>No Email Schedules Found</h3>
                                <p className="text-muted">Click "Add New Schedule" to create your first email schedule</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showPopup && (
                <AddEmailSchedulerPopup 
                    onClose={handleClosePopup}
                    data={popupData}
                    onSuccess={handlePopupSuccess}
                    updating={updating}
                />
            )}

            {/* {showDeleteModal && (
                <DeclinePopup
                    title={`Delete "${itemToDelete?.name}" Schedule?`}
                    subtitle="Are you sure you want to delete this schedule? This action cannot be undone."
                    onClose={handleCloseDeleteModal}
                    onSuccess={handleDeleteConfirm}
                />
            )} */}
        </>
    );
};